import { lightColors } from "./Colors";
import { space } from "./Space";
import { apolloFontFamilyHeading1, apolloLineHeightHeading1, apolloFontWeightHeading1, apolloFontSizeHeading1, apolloFontFamilyHeading2, apolloFontWeightHeading2, apolloFontSizeHeading2, apolloLineHeightHeading2, apolloFontFamilyHeading3, apolloFontWeightHeading3, apolloFontSizeHeading3, apolloLineHeightHeading3, apolloLetterSpacingHeading3, apolloFontFamilyHeading4, apolloFontWeightHeading4, apolloFontSizeHeading4, apolloLineHeightHeading4, apolloFontFamilyHeading5, apolloFontWeightHeading5, apolloFontSizeHeading5, apolloLineHeightHeading5, apolloFontFamilyHeading6, apolloFontWeightHeading6, apolloFontSizeHeading6, apolloLineHeightHeading6, apolloFontFamilyHeading2Light, apolloFontWeightHeading2Light, apolloFontSizeHeading2Light, apolloLineHeightHeading2Light, apolloFontFamilyDisplay, apolloFontWeightDisplay, apolloFontSizeDisplay, apolloLineHeightDisplay, apolloFontFamilyDisplayData, apolloFontWeightDisplayData, apolloFontSizeDisplayData, apolloLineHeightDisplayData, apolloFontFamilyBody, apolloFontWeightBody, apolloFontSizeBody, apolloLineHeightBody, apolloFontFamilyBodySmall, apolloFontWeightBodySmall, apolloFontSizeBodySmall, apolloLineHeightBodySmall, apolloFontFamilyBodyStrong, apolloFontWeightBodyStrong, apolloFontSizeBodyStrong, apolloLineHeightBodyStrong, apolloFontFamilySub, apolloFontWeightSub, apolloFontSizeSub, apolloLineHeightSub, apolloFontFamilySubStrong, apolloFontWeightSubStrong, apolloFontSizeSubStrong, apolloLineHeightSubStrong, apolloFontFamilyRibbonTitle, apolloFontWeightRibbonTitle, apolloFontSizeRibbonTitle, apolloLineHeightRibbonTitle, apolloFontFamilyPill, apolloFontWeightPill, apolloFontSizePill, apolloLineHeightPill, apolloFontFamilyButtonLabel, apolloFontWeightButtonLabel, apolloFontSizeButtonLabel, apolloLineHeightButtonLabel, apolloFontFamilyBodySmallStrong, apolloFontSizeBodySmallStrong, apolloFontWeightBodySmallStrong, apolloLineHeightBodySmallStrong, apolloFontFamilyVerySmall, apolloFontWeightVerySmall, apolloFontSizeVerySmall, apolloLineHeightVerySmall, apolloFontFamilyHeaderSecondaryTitle, apolloFontWeightHeaderSecondaryTitle, apolloFontSizeHeaderSecondaryTitle, apolloLineHeightHeaderSecondaryTitle, apolloFontFamilyHeaderMainTitle, apolloFontSizeHeaderMainTitle, apolloFontWeightHeaderMainTitle, apolloLineHeightHeaderMainTitle, apolloLetterSpacingHeaderMainTitle, apolloFontFamilyTileDisplay, apolloFontSizeTileDisplay, apolloFontWeightTileDisplay, apolloLineHeightTileDisplay, apolloLetterSpacingTileDisplay, apolloFontFamilyEyebrowSmall, apolloFontSizeEyebrowSmall, apolloFontWeightEyebrowSmall, apolloLineHeightEyebrowSmall, apolloFontFamilyCode, apolloFontSizeCode, apolloFontWeightCode, apolloLineHeightCode, apolloLetterSpacingDisplay, apolloFontFamilyDisplaySmall, apolloFontSizeDisplaySmall, apolloFontWeightDisplaySmall, apolloLetterSpacingDisplaySmall, apolloLineHeightDisplaySmall, apolloFontFamilyBodyXlarge, apolloFontSizeBodyXlarge, apolloFontWeightBodyXlarge, apolloLineHeightBodyXlarge, apolloFontStyleSub, apolloFontFamilyBodyEmphasis, apolloFontWeightBodyEmphasis, apolloFontSizeBodyEmphasis, apolloLineHeightBodyEmphasis, apolloFontStyleBodyEmphasis, apolloFontStyleHeading1, apolloFontStyleHeading2, apolloFontStyleHeading2Light, apolloFontStyleHeading3, apolloFontStyleHeading4, apolloFontStyleHeading5, apolloFontStyleHeading6, apolloFontStyleDisplay, apolloFontStyleDisplaySmall, apolloFontStyleDisplayData, apolloFontStyleBodyXlarge, apolloFontStyleBodyStrong, apolloFontStyleBody, apolloFontStyleBodySmallStrong, apolloFontStyleBodySmall, apolloFontStyleSubStrong, apolloFontStyleEyebrowSmall, apolloFontStyleVerySmall, apolloFontStyleRibbonTitle, apolloFontStylePill, apolloFontStyleButtonLabel, apolloFontStyleHeaderMainTitle, apolloFontStyleHeaderSecondaryTitle, apolloFontStyleTileDisplay, apolloFontStyleCode, } from "@nexthink/apollo-tokens/lib/tokens";
const textStyles = {
    heading1: {
        fontFamily: apolloFontFamilyHeading1,
        fontWeight: apolloFontWeightHeading1,
        fontSize: apolloFontSizeHeading1,
        lineHeight: apolloLineHeightHeading1,
        fontStyle: apolloFontStyleHeading1,
    },
    heading2: {
        fontFamily: apolloFontFamilyHeading2,
        fontWeight: apolloFontWeightHeading2,
        fontSize: apolloFontSizeHeading2,
        lineHeight: apolloLineHeightHeading2,
        fontStyle: apolloFontStyleHeading2,
    },
    heading2Light: {
        fontFamily: apolloFontFamilyHeading2Light,
        fontWeight: apolloFontWeightHeading2Light,
        fontSize: apolloFontSizeHeading2Light,
        lineHeight: apolloLineHeightHeading2Light,
        fontStyle: apolloFontStyleHeading2Light,
    },
    heading3: {
        fontFamily: apolloFontFamilyHeading3,
        fontWeight: apolloFontWeightHeading3,
        fontSize: apolloFontSizeHeading3,
        lineHeight: apolloLineHeightHeading3,
        letterSpacing: apolloLetterSpacingHeading3,
        fontStyle: apolloFontStyleHeading3,
    },
    heading4: {
        fontFamily: apolloFontFamilyHeading4,
        fontWeight: apolloFontWeightHeading4,
        fontSize: apolloFontSizeHeading4,
        lineHeight: apolloLineHeightHeading4,
        fontStyle: apolloFontStyleHeading4,
    },
    heading5: {
        fontFamily: apolloFontFamilyHeading5,
        fontWeight: apolloFontWeightHeading5,
        fontSize: apolloFontSizeHeading5,
        lineHeight: apolloLineHeightHeading5,
        fontStyle: apolloFontStyleHeading5,
    },
    heading6: {
        fontFamily: apolloFontFamilyHeading6,
        fontWeight: apolloFontWeightHeading6,
        fontSize: apolloFontSizeHeading6,
        lineHeight: apolloLineHeightHeading6,
        fontStyle: apolloFontStyleHeading6,
    },
    display: {
        fontFamily: apolloFontFamilyDisplay,
        fontWeight: apolloFontWeightDisplay,
        fontSize: apolloFontSizeDisplay,
        lineHeight: apolloLineHeightDisplay,
        letterSpacing: apolloLetterSpacingDisplay,
        fontStyle: apolloFontStyleDisplay,
    },
    displaySmall: {
        fontFamily: apolloFontFamilyDisplaySmall,
        fontWeight: apolloFontWeightDisplaySmall,
        fontSize: apolloFontSizeDisplaySmall,
        lineHeight: apolloLineHeightDisplaySmall,
        letterSpacing: apolloLetterSpacingDisplaySmall,
        fontStyle: apolloFontStyleDisplaySmall,
    },
    displayData: {
        fontFamily: apolloFontFamilyDisplayData,
        fontWeight: apolloFontWeightDisplayData,
        fontSize: apolloFontSizeDisplayData,
        lineHeight: apolloLineHeightDisplayData,
        fontStyle: apolloFontStyleDisplayData,
    },
    body: {
        fontFamily: apolloFontFamilyBody,
        fontWeight: apolloFontWeightBody,
        fontSize: apolloFontSizeBody,
        lineHeight: apolloLineHeightBody,
        fontStyle: apolloFontStyleBody,
    },
    bodySmall: {
        fontFamily: apolloFontFamilyBodySmall,
        fontWeight: apolloFontWeightBodySmall,
        fontSize: apolloFontSizeBodySmall,
        lineHeight: apolloLineHeightBodySmall,
        fontStyle: apolloFontStyleBodySmall,
    },
    bodyStrong: {
        fontFamily: apolloFontFamilyBodyStrong,
        fontWeight: apolloFontWeightBodyStrong,
        fontSize: apolloFontSizeBodyStrong,
        lineHeight: apolloLineHeightBodyStrong,
        fontStyle: apolloFontStyleBodyStrong,
    },
    bodySmallStrong: {
        fontFamily: apolloFontFamilyBodySmallStrong,
        fontWeight: apolloFontWeightBodySmallStrong,
        fontSize: apolloFontSizeBodySmallStrong,
        lineHeight: apolloLineHeightBodySmallStrong,
        fontStyle: apolloFontStyleBodySmallStrong,
    },
    bodyXlarge: {
        fontFamily: apolloFontFamilyBodyXlarge,
        fontWeight: apolloFontWeightBodyXlarge,
        fontSize: apolloFontSizeBodyXlarge,
        lineHeight: apolloLineHeightBodyXlarge,
        fontStyle: apolloFontStyleBodyXlarge,
    },
    verySmall: {
        fontFamily: apolloFontFamilyVerySmall,
        fontWeight: apolloFontWeightVerySmall,
        fontSize: apolloFontSizeVerySmall,
        lineHeight: apolloLineHeightVerySmall,
        fontStyle: apolloFontStyleVerySmall,
    },
    sub: {
        fontFamily: apolloFontFamilySub,
        fontWeight: apolloFontWeightSub,
        fontSize: apolloFontSizeSub,
        lineHeight: apolloLineHeightSub,
        fontStyle: apolloFontStyleSub,
    },
    subStrong: {
        fontFamily: apolloFontFamilySubStrong,
        fontWeight: apolloFontWeightSubStrong,
        fontSize: apolloFontSizeSubStrong,
        lineHeight: apolloLineHeightSubStrong,
        fontStyle: apolloFontStyleSubStrong,
    },
    ribbonTitle: {
        fontFamily: apolloFontFamilyRibbonTitle,
        fontWeight: apolloFontWeightRibbonTitle,
        fontSize: apolloFontSizeRibbonTitle,
        lineHeight: apolloLineHeightRibbonTitle,
        fontStyle: apolloFontStyleRibbonTitle,
    },
    pill: {
        fontFamily: apolloFontFamilyPill,
        fontWeight: apolloFontWeightPill,
        fontSize: apolloFontSizePill,
        lineHeight: apolloLineHeightPill,
        fontStyle: apolloFontStylePill,
    },
    buttonLabel: {
        fontFamily: apolloFontFamilyButtonLabel,
        fontWeight: apolloFontWeightButtonLabel,
        fontSize: apolloFontSizeButtonLabel,
        lineHeight: apolloLineHeightButtonLabel,
        fontStyle: apolloFontStyleButtonLabel,
    },
    mainTitle: {
        fontFamily: apolloFontFamilyHeaderMainTitle,
        fontWeight: apolloFontWeightHeaderMainTitle,
        fontSize: apolloFontSizeHeaderMainTitle,
        lineHeight: apolloLineHeightHeaderMainTitle,
        letterSpacing: apolloLetterSpacingHeaderMainTitle,
        fontStyle: apolloFontStyleHeaderMainTitle,
    },
    secondaryTitle: {
        fontFamily: apolloFontFamilyHeaderSecondaryTitle,
        fontWeight: apolloFontWeightHeaderSecondaryTitle,
        fontSize: apolloFontSizeHeaderSecondaryTitle,
        lineHeight: apolloLineHeightHeaderSecondaryTitle,
        fontStyle: apolloFontStyleHeaderSecondaryTitle,
    },
    tileDisplay: {
        fontFamily: apolloFontFamilyTileDisplay,
        fontWeight: apolloFontWeightTileDisplay,
        fontSize: apolloFontSizeTileDisplay,
        lineHeight: apolloLineHeightTileDisplay,
        letterSpacing: apolloLetterSpacingTileDisplay,
        fontStyle: apolloFontStyleTileDisplay,
    },
    eyeBrowSmall: {
        fontFamily: apolloFontFamilyEyebrowSmall,
        fontWeight: apolloFontWeightEyebrowSmall,
        fontSize: apolloFontSizeEyebrowSmall,
        lineHeight: apolloLineHeightEyebrowSmall,
        fontStyle: apolloFontStyleEyebrowSmall,
    },
    code: {
        fontFamily: apolloFontFamilyCode,
        fontWeight: apolloFontWeightCode,
        fontSize: apolloFontSizeCode,
        lineHeight: apolloLineHeightCode,
        fontStyle: apolloFontStyleCode,
    },
    bodyEmphasis: {
        fontFamily: apolloFontFamilyBodyEmphasis,
        fontWeight: apolloFontWeightBodyEmphasis,
        fontSize: apolloFontSizeBodyEmphasis,
        lineHeight: apolloLineHeightBodyEmphasis,
        fontStyle: apolloFontStyleBodyEmphasis,
    },
};
const apolloTheme = {
    name: "light",
    space,
    colors: Object.assign({}, lightColors),
    textStyles,
    level: 1,
};
export default apolloTheme;
export const rootRemSize = 16;
//# sourceMappingURL=Theme.js.map